import * as Styles from './styles'

interface Props {
    description: string
    date: string
}

export const LogItem = (props: Props) => {
    return (
        <Styles.Container>
            <Styles.Description>
                {props.description}
            </Styles.Description>
            <Styles.Date>
                {props.date}
            </Styles.Date>
        </Styles.Container>
    )
}
